// Lightweight cross-component signal to refetch the wallet balance (topbar widget, billing
// page) after something changed it - checkout return, subscription cancel, completed generation.
// A window event instead of a store keeps the payment UI decoupled from the generation hooks.

export const WALLET_REFRESH_EVENT = 'sengi:wallet-refresh';

export const requestWalletRefresh = (delayMs = 0) => {
    // The wallet debit after a completed run happens asynchronously server-side (see
    // PortalBackend API.md, PUT /runs/:id/complete) - an immediate refetch can race it, so
    // callers in the generation path pass a small delay.
    setTimeout(() => window.dispatchEvent(new CustomEvent(WALLET_REFRESH_EVENT)), delayMs);
};
